<template>
  <b-container fluid>
    <b-card
      class="m-4"
      :header=" this.$route.params.id ? 'Editar tipo de plantão': 'Adicionar tipo de plantão'"
      header-text-variant="white"
      header-tag="header"
      header-bg-variant="success"
      footer-tag="footer"
    >
      <b-card-text>
        <b-form>
          <b-row>
            <b-col class="col-12 col-md-6">
              <b-form-group id="descricao-fg" label="Descrição" label-for="descricao">
                <b-form-input
                  id="descricao"
                  name="descricao"
                  :state="$v.tipoplantao.descricao.$error ? false : null"
                  v-model="tipoplantao.descricao"
                  class="mb-3"
                  aria-describedby="descricao-feedback"
                ></b-form-input>

                <b-form-invalid-feedback id="descricao-feedback">Digite uma descrição.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col class="d-flex flex-row">
              <b-form-group id="ativo-fg" label="Ativo" label-for="ativo">
                <b-form-checkbox id="ativo" v-model="tipoplantao.ativo" switch size="lg"></b-form-checkbox>
              </b-form-group>
              <b-form-group id="noturno-fg" label="Noturno" label-for="noturno">
                <b-form-checkbox id="noturno" v-model="tipoplantao.noturno" switch size="lg"></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="hora-inicio-form-group"
                label="Hora de início"
                label-for="hora-inicio"
              >
                <b-form-timepicker
                  id="hora-inicio"
                  name="hora-inicio"
                  :state="$v.tipoplantao.hora_inicio.$error ? false : null"
                  v-model="tipoplantao.hora_inicio"
                  class="mb-3"
                  aria-describedby="hora-inicio-feedback"
                ></b-form-timepicker>

                <b-form-invalid-feedback id="hora-inicio-feedback"
                  >Escolha uma hora de início.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="hora-fim-form-group"
                label="Hora de fim"
                label-for="hora-fim"
              >
                <b-form-timepicker
                  id="hora-fim"
                  name="hora-fim"
                  :state="$v.tipoplantao.hora_fim.$error ? false : null"
                  v-model="tipoplantao.hora_fim"
                  class="mb-3"
                  aria-describedby="hora-fim-feedback"
                ></b-form-timepicker>

                <b-form-invalid-feedback id="hora-fim-feedback"
                  >Escolha uma hora de fim.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label for="refeicoes-tipoplantao">Refeições no plantão</label>
              <b-table
                id="refeicoes-tipoplantao"
                :items="tipoplantao.refeicoes"
                small
                :fields="campos_tabela"
                sticky-header
                selectable
                @row-selected="selecionaRefeicoesPlantao"
              ></b-table>
            </b-col>
            <b-col
              class="col-lg-1 d-flex col-12 flex-row flex-lg-column justify-content-center botoes-controle"
            >
              <b-button class="m-1" variant="primary" @click="removeTodosPlantao">
                <i class="fa fa-angle-double-right d-none d-lg-inline"></i>
                <i class="fa fa-angle-double-down d-inline d-lg-none"></i>
              </b-button>
              <b-button class="m-1" variant="primary" @click="removeSelecionadosDoPlantao">
                <i class="fa fa-angle-right d-none d-lg-inline"></i>
                <i class="fa fa-angle-down d-inline d-lg-none"></i>
              </b-button>
              <b-button class="m-1" variant="primary" @click="adicionaTodosPlantao">
                <i class="fa fa-angle-double-left d-none d-lg-inline"></i>
                <i class="fa fa-angle-double-up d-inline d-lg-none"></i>
              </b-button>
              <b-button class="m-1" variant="primary" @click="adicionaSelecionadosAoPlantao">
                <i class="fa fa-angle-left d-none d-lg-inline"></i>
                <i class="fa fa-angle-up d-inline d-lg-none"></i>
              </b-button>
            </b-col>
            <b-col>
              <label for="refeicoes-geral">Todas as refeições</label>
              <b-table
                id="refeicoes-geral"
                :items="refeicoes"
                small
                :fields="campos_tabela"
                sticky-header
                selectable
                @row-selected="selecionaRefeicoesGeral"
              ></b-table>
            </b-col>
          </b-row>
        </b-form>
      </b-card-text>
      <template v-slot:footer>
        <b-container id="rodape" fluid>
          <b-row>
            <b-col>
              <b-button
                variant="success"
                @click="salvarPlantao"
              >{{ tipoplantao.id != null ? "Salvar alterações" : "Salvar" }}</b-button>
              <b-button class="ml-2" variant="danger" to="/tiposdeplantao">Cancelar</b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-card>
  </b-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import mixinToast from "@/mixins/mixinToast.js";

export default {
  mixins: [mixinToast],
  data() {
    return {
      campos_tabela: [
        { key: "descricao", label: "Descrição" }
      ],
      tipoplantao: {
        id: null,
        descricao: "",
        ativo: true,
        hora_inicio: null,
        hora_fim: null,
        noturno: false,
        refeicoes: []
      },
      refeicoes: [],
      refeicoesSelecionadasPlantao: [],
      refeicoesSelecionadas: [],
    };
  },
  validations: {
    tipoplantao: {
      descricao: {
        required
      },
      refeicoes: {
        required
      },
      hora_inicio: {
        required
      },
      hora_fim: {
        required
      }
    }
  },
  methods: {
    removeTodosPlantao() {
      this.tipoplantao.refeicoes = [];
    },
    adicionaTodosPlantao() {
      this.tipoplantao.refeicoes = [];
      this.tipoplantao.refeicoes = this.refeicoes;
    },
    removeSelecionadosDoPlantao() {
      this.refeicoesSelecionadasPlantao.forEach(element => {
        this.tipoplantao.refeicoes = this.tipoplantao.refeicoes.filter(v => {
          return element.id != v.id;
        });
      });
    },
    adicionaSelecionadosAoPlantao() {
      this.refeicoesSelecionadas.forEach(element => {
        //primeiro verifica se a permissão já existe no tipoplantao
        const jaExiste = this.tipoplantao.refeicoes.find(v => {
          return v.id == element.id;
        });

        if (!jaExiste) {
          this.tipoplantao.refeicoes.push(element);
        }
      });
    },
    selecionaRefeicoesPlantao(items) {
      this.refeicoesSelecionadasPlantao = items;
    },
    selecionaRefeicoesGeral(items) {
      this.refeicoesSelecionadas = items;
    },
    salvarPlantao() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$bvModal
          .msgBoxConfirm("Deseja salvar o registro?", {
            title: "Confirmação?",
            okVariant: "success",
            okTitle: "Sim",
            cancelTitle: "Não",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            if (value) {
              this.$http.post("/tiposdeplantao", this.tipoplantao).then(result => {
                this.exibeToast(result.data.success, result.data.message);
              });
            }
          });
      }
    }
  },
  mounted() {
    //se tiver setado id nos parâmetros é porque é uma edição, então vamos ao backend pegar os dados que se quer editar
    this.$http.get("/tipoderefeicao").then(result => {
      this.refeicoes = result.data;
    });

    if (this.$route.params.id) {
      const id = this.$route.params.id;
      this.$http.get(`/tiposdeplantao/${id}`).then(result => {
        this.tipoplantao = result.data;
      });
    }
  }
};
</script>

<style>
.p-picklist-source-controls,
.p-picklist-target-controls {
  display: none;
}
.botoes-controle > button {
  width: 40px;
}
</style>